import api from '../../../api/clinique/_ordonnance'

const state = () => ({
    liste_ordonnances_patient: []
})

// getters
const getters = {
    liste_ordonnances_patient: (state) => {
        return state.liste_ordonnances_patient
    },
}

// mutations
const mutations = {
    SET_LISTE_ORDONNANCES_PATIENT(state, liste) {
        state.liste_ordonnances_patient = liste
    },
}

// actions
const actions = {
    getListeOrdonnancePatientByListeOrdonnance({ commit }, data) {
        return new Promise((resolve, reject) => {
            api.getListeOrdonnancePatientByListeOrdonnance(data).then(
                response => {
                    commit('SET_LISTE_ORDONNANCES_PATIENT', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}